// import {} from 'jquery-ujs';
// import "@hotwired/turbo-rails";
//
import "utilities/sentry";
import "utilities/jquery.shim";
import "./application";

import "vendor/jquery-ui.admin";
import "vendor/jquery.mjs.nestedSortable";

import ActionCable from "actioncable";
window.Cable = ActionCable.createConsumer();
import "admin/cable";
import "admin/editor";
import "admin/crop_image";
import "vendor/jquery.serializejson";

import "components/form";

import "user";
